import { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster as SonnerToaster } from "@/components/ui/sonner";
import { Toaster as ToastToaster } from "@/components/ui/toaster";
import { queryClient } from "@/lib/react-query";
import { AuthProvider } from "@/contexts/auth";
import { ProfileProvider } from "@/contexts/profile/ProfileContext";
import { FeatureFlagsProvider } from "@/contexts/featureFlags/FeatureFlagsContext";
import { FavoritesProvider } from "@/contexts/FavoritesProvider";
import LanguageFeatureGate from "@/components/LanguageFeatureGate";

interface AppProvidersProps {
  children: ReactNode;
}

const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ProfileProvider>
          <FeatureFlagsProvider>
            <LanguageFeatureGate />
            <FavoritesProvider>
              <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
                <TooltipProvider>
                  {children}
                  <ToastToaster />
                  <SonnerToaster position="bottom-right" />
                </TooltipProvider>
              </ThemeProvider>
            </FavoritesProvider>
          </FeatureFlagsProvider>
        </ProfileProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default AppProviders;